import React from 'react';

export default function FieldSeparator() {
  return <hr />;
}
